import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { NewspaperModule } from './admin/newspaper/newspaper.module';
import { AuthGuard } from './services/auth.guard';

const routes: Routes = [
  { path:'',redirectTo:'/admin/panel/dashboard',pathMatch:'full'},
  { path: 'auth', loadChildren:'./auth/auth.module#AuthModule'},
  { path: 'report', loadChildren:'./reports/reports.module#ReportsModule', canActivate:[AuthGuard]},
  { path: 'admin',loadChildren: './admin/admin.module#AdminModule', canActivate:[AuthGuard]}
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})



export class AppRoutingModule { }
